export const PIPELINE_STATUS_TITLE = 'Pipeline by milestone';

export const PIPELINE_STATUS_AS_OF_PREFIX = 'Snapshot as of';

export const PIPELINE_STATUS_AS_OF_FALLBACK = 'Snapshot freshness unavailable';

export const PIPELINE_STATUS_SUBTITLE_SUFFIX =
  'excludes withdrawn and declined · click a stage to drill in';

export const PIPELINE_STATUS_EMPTY_TEXT = 'No active loans in the pipeline yet';

export const PIPELINE_STATUS_WIDGET_TYPE = 'MilestoneBreakdown';
